import { Color } from '@coast/schemas';
import React from 'react';
import { useTagOptions } from '@shared/components/blocks/lib/tags/hooks';
import { notNil } from '@shared/util/notNil';
import { Tag } from './tag';
import { getTagOption } from './index';

interface Props {
  fieldName: string;
  tagValues: string[];
}

export function TagList({ fieldName, tagValues }: Props) {
  const { options } = useTagOptions(fieldName);
  if (!tagValues) {
    return null;
  }

  const tags = tagValues.map(value => getTagOption(value, options)).filter(notNil);

  return (
    <>
      {tags.map(tag => {
        return (
          <Tag
            key={tag.id}
            color={tag.colorName as Color}
            archived={!!tag.archivedAt}
            label={tag.label}
          />
        );
      })}
    </>
  );
}
